<template>
  <div class="combined-wrapper">
    <!-- Full 1920x1080 canvas -->
    <div class="canvas-container">
      <!-- Combined QR Code + Poll Unit - aligned at bottom -->
      <div class="poll-qrcode-unit">
        <!-- QR Code Section - positioned to the left of the poll -->
        <div v-if="hasValidQRCode" class="qrcode-section">
          <div class="qrcode-container">
            <img
              :src="qrCodeUrl"
              :alt="qrCodeAltText"
              class="qrcode-image"
              @error="onQRCodeError"
            />
          </div>
          <div class="participe-label">
            <span>{{ participateLabel }}</span>
          </div>
        </div>

        <!-- Poll Section -->
        <div class="poll-section">
          <CardTarjaEnqueteTVZ
            :item="item"
            :posicaoEnquete="posicaoEnquete"
            :hideTitle="hideTitle"
            :hideOptionTitle="hideOptionTitle"
            :isVerticalBar="isVerticalBar"
            :isRenderedWithQRCode="true"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CardTarjaEnqueteTVZ from "./CardTarjaEnqueteTVZ.vue";

export default {
  name: "TarjaEnqueteTVZWithQRCode",

  components: {
    CardTarjaEnqueteTVZ,
  },

  props: {
    item: {
      type: Object,
      required: true,
    },
    qrCode: {
      type: Object,
      default: null, // { url: "..." }
    },
    participateLabel: {
      type: String,
      default: "Participe!",
    },
    posicaoEnquete: {
      type: String,
      default: "esquerda",
    },
    hideTitle: {
      type: Boolean,
      default: false,
    },
    hideOptionTitle: {
      type: Boolean,
      default: false,
    },
    isVerticalBar: {
      type: Boolean,
      default: false,
    },
    isFullScreen: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    hasValidQRCode() {
      const qrUrl = this.qrCodeUrl;
      return qrUrl && qrUrl.trim() !== "";
    },

    qrCodeUrl() {
      // Support both item.enquete_qr_code.url and qrCode prop
      return this.qrCode?.url || this.item?.enquete_qr_code?.url || null;
    },

    qrCodeAltText() {
      return `QR Code - ${this.item?.dsc_titulo_enquete || "Participe da Enquete"}`;
    },
  },

  methods: {
    onQRCodeError(event) {
      console.error("Error loading QR Code image:", event);
      this.$emit("qrcode-error", {
        url: this.qrCodeUrl,
        enqueteId: this.item?.id,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@font-face {
  font-family: "Gobold Regular";
  src: url("@/assets/Gobold_Regular.otf") format("opentype");
}

$qrcode-size: 120px;
$qrcode-border: 8px;
$qrcode-gap: 20px;

.combined-wrapper {
  --qrcode-border-color: #00a493;
  --participe-label-background: #00a493;
  --participe-label-text: #ffffff;

  position: relative;
  top: 0;
  left: 0;
  width: 1920px;
  height: 1080px;
  overflow: hidden;
  pointer-events: none;
}

.canvas-container {
  position: relative;
  width: 100%;
  height: 100%;
}

/* Combined unit - flexbox aligns QR and poll vertically at bottom */
.poll-qrcode-unit {
  position: absolute;
  bottom: 20px;
  left: 0;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  padding-left: 5%; /* Match the 90% width of poll (5% margin each side) */
}

/* QR Code Section - vertically aligned with the poll bar */
.qrcode-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  border: $qrcode-border solid var(--qrcode-border-color);
  background-color: #ffffff;
  pointer-events: auto;
  margin-right: $qrcode-gap;
  margin-bottom: 10px; /* Small offset from bottom */
  flex-shrink: 0;
}

.qrcode-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
  background-color: #ffffff;
}

.qrcode-image {
  width: $qrcode-size;
  height: $qrcode-size;
  object-fit: contain;
}

.participe-label {
  background: var(--participe-label-background);
  width: 100%;
  padding: 6px 12px;

  span {
    display: block;
    font-family: "Gobold Regular", "Arial Black", sans-serif;
    font-weight: 900;
    font-size: 18px;
    color: var(--participe-label-text);
    text-align: center;
    text-transform: uppercase;
    letter-spacing: 0.02em;
  }
}

/* Poll Section - takes remaining width */
.poll-section {
  //   flex: 1;
  position: relative;
  height: 151px; /* Match poll bar height */
  pointer-events: auto;
  bottom: 20px;

  /* Reset the absolute positioning of the inner poll component */
  ::v-deep .enquete-wrapper {
    position: relative;
    bottom: auto;
    left: auto;
    // width: 100%;
  }

  ::v-deep .enquete-bg {
    // width: 100%;
    margin: 0;
  }

  ::v-deep .enquete-overlay {
    // width: 100%;
    margin: 0;
  }
}
</style>
